export default __webpack_public_path__ + "75be9a1289bea5670239b487f7b68a28.svg";